import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"
import _imports_0 from '@/assets/images/dreAvatar.png'


const _hoisted_1 = {
  key: 0,
  class: "counter"
}
const _hoisted_2 = {
  key: 0,
  class: "dre-tray-overlay"
}
const _hoisted_3 = {
  key: 1,
  class: "dre-tray"
}
const _hoisted_4 = { class: "dre-tray__main" }
const _hoisted_5 = { class: "dre-tray__main__messages" }
const _hoisted_6 = {
  key: 0,
  class: "waiting-animation"
}
const _hoisted_7 = { class: "dre-tray-message__content" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dre-tray-message__avatar" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    loading: "lazy"
  })
], -1)
const _hoisted_9 = { class: "dre-tray-message__message" }
const _hoisted_10 = { class: "dre-tray-message__message__bubble" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppDre = _resolveComponent("AppDre")!
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_CommentSpinner = _resolveComponent("CommentSpinner")!
  const _component_DreTrayMessageComponent = _resolveComponent("DreTrayMessageComponent")!
  const _component_AppTextarea = _resolveComponent("AppTextarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["dre-toggle", { 'closed': _ctx.dreTrayOpen, 'unread': _ctx.unread }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleDreTray()))
    }, [
      (_ctx.unread && !_ctx.dreTrayOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.unread), 1))
        : _createCommentVNode("", true),
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (!_ctx.dreTrayOpen)
            ? (_openBlock(), _createBlock(_component_AppDre, {
                key: 0,
                variant: 'happy',
                animate: true
              }))
            : (_openBlock(), _createBlock(_component_AppIcon, {
                key: 1,
                name: "close",
                size: "12"
              }))
        ]),
        _: 1
      })
    ], 2),
    (_ctx.dreTrayOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.dreTrayOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.isWaitingForResponse)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_component_CommentSpinner)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, index) => {
                return (_openBlock(), _createBlock(_component_DreTrayMessageComponent, {
                  key: index,
                  message: message,
                  onOnPillSelect: _ctx.onPillSelect
                }, null, 8, ["message", "onOnPillSelect"]))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["dre-tray__main__prompt", { 'dre-tray__main__prompt__editing': _ctx.isEditing }])
            }, [
              _createVNode(_component_AppTextarea, {
                id: "dre-tray-prompt",
                type: "text",
                placeholder: "Ask Dre anything work related..",
                modelValue: _ctx.prompt,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.prompt) = $event)),
                rows: "3",
                onKeydown: _withKeys(_withModifiers(_ctx.submitPrompt, ["prevent"]), ["enter"]),
                onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.markRead()))
              }, null, 8, ["modelValue", "onKeydown"])
            ], 2)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}